export default __webpack_public_path__ + "static/media/Taken.4780ad28.svg";